// extracted by mini-css-extract-plugin
module.exports = {"question":"gzRbXZdZMAsEVSrbZe8Ms","questionText":"_3PEl_9LVa06ZWOSrvWEYFX","answer":"_1UJHnphYlIxtTZjJzmvWTf","icon":"_2NNx1oyNg0tYqYVMJNqgmv"};